import { connect } from 'react-redux'
import validator from 'email-validator'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'

import page from 'page'
import classNames from 'classnames'

import pixel from 'react-facebook-pixel'
import timeout from './../helpers/rAF'
import { fetchingState } from './../helpers/hocs.js'
import { subscribe } from './../store/reducers/home'
import { getContacts } from '../store/reducers/contacts'
import { getCountries } from '../store/reducers/countries'
import { getUser, logOut } from '../store/reducers/auth.js'
import { getIsLogged, getLoggedUser } from '../selectors/user.js'

// Containers
/*import Lot from './Lot'
import FixedPriceLot from './FixedPriceLot'
import Pay from './Pay'
import Checkout from './Checkout'*/
import Home from './Home'
/*import Lots from './Lots'
import FixedPriceLots from './FixedPriceLots'*/
import News from './News'
import Found from './Fund'
//import Help from './Help'
import About from './About'
import Founds from './Funds'
import NotFound from './404'
import Search from './Search'
//import Signin from './Signin'
//import Member from './Member'
//import Profile from './Profile'
//import Members from './Members'
import Article from './Article'
import Contacts from './Contacts'
import Partners from './Partners'
import Static from './Static'
//import Video from './Video'
import Actions from './Actions'
import Action from './Action'
import Offer from './Offer'
import ExternalPartners from './ExternalPartners';
import ExternalPartner from './ExternalPartner';
import Donate from './Buttons/Donate';
import DonateOptions from './Buttons/DonateOptions';
import DonateKynsi from './Buttons/DonateKynsi';
import TravliNet from './Buttons/TravliNet';
// Components
import Header from './../components/Header'
import Footer from './../components/Footer'
import Menu from './../components/MobileMenu'
import Overlay from './../components/Overlay'

//import EditForm from './../components/Profile/Edit'
//import ClaimForm from './../components/Profile/Claim'

//import Region from './../components/Region/Region'

class MainLayout extends Component {
  constructor (props) {
    super(props)

    this.state = {
      removeDelay: false,
      isIndex: true,
      /*isSignin: false,*/
      isSearch: false,
      isLight: false,
      isHalfLight: false,
      isMenuOpen: false,
      container: null,
      isOverlap: false,
      //isRegion: false,
      modalState: {},
      isMenuLight: false,
    }

    this.handle404 = this.handle404.bind(this)
    /*this.handleCloseSigin = this.handleCloseSigin.bind(this)
    this.handleOpenSigin = this.handleOpenSigin.bind(this)
    this.handleCloseRegion = this.handleCloseRegion.bind(this)
    this.handleOpenRegion = this.handleOpenRegion.bind(this)*/
    this.handleOpenSearch = this.handleOpenSearch.bind(this)
    this.handleCloseSearch = this.handleCloseSearch.bind(this)
    this.handleMenuOpen = this.handleMenuOpen.bind(this)
    this.handleMenuClose = this.handleMenuClose.bind(this)
  }

  setModalState (name, flag, e) {
    e && e.preventDefault()
    if ([ 'claim', 'edit' ].indexOf(name) === -1) return
    this.setState(state => ({
      modalState: { ...state.modalState, [name]: flag }
    }))
  }

  /*handleCloseSigin () {
    this.setState({ isSignin: false })
  }

  handleCloseRegion () {
    this.setState({ isRegion: false })
  }

  handleOpenRegion () {
    this.setState({ isRegion: true })
  }

  handleOpenSigin () {
    this.setState({ isSignin: true })
  }*/

  handleCloseSearch () {
    this.setState({ isSearch: false })
  }

  handleOpenSearch () {
    this.setState({ isSearch: true })
  }

  handleMenuClose () {
    document.body.classList.add('_animate-menu-close')

    timeout(() => {
      this.setState({ isMenuOpen: false })
      document.body.classList.remove('_animate-menu-close')
    }, 500)

    window.unfreezeBody()
  }

  handleMenuOpen () {
    this.setState({ isMenuOpen: true })
    window.freezeBody()
  }

  handle404 () {
    this.setState({
      container: <NotFound />,
      isIndex: false,
      isLight: true,
      isHalfLight: false
    })
  }

  componentWillMount () {
    this.props.getInitialData()
  }

  componentDidMount () {
    const self = this
    let bodyScrollTop

    if (!window.__PIXEL) {
      pixel.init('1939222209737765')
      pixel.pageView()
      window.__PIXEL = true
    }

    // Routing
    // ------------------------------------------------------------------------
    page('*', (ctx, next) => {
      if (ctx.init) next()
      else {
        document.body.classList.add('is-animate')

        timeout(() => {
          window.scrollTo(0, 0)
        }, 300)

        timeout(() => {
          document.body.classList.remove('is-animate')
          next()
        }, 400)
      }
    })

    page('/404', () => {
      self.setState({
        container: <NotFound />,
        isIndex: false,
        isLight: true,
        isHalfLight: false,
      })
    })

    page('/', (ctx) => {
      self.setState({
        container: <Home />,
        isIndex: true,
        isLight: false,
        isHalfLight: false,
        isMenuLight: false//true,
      })
    })

    page('/contacts', (ctx) => {
      self.setState({
        container: <Contacts />,
        isIndex: false,
        isLight: false,//true
        isHalfLight: false,
        isMenuLight: false,
      })
    })

    page('/funds', (ctx) => {
      self.setState({
        container: <Founds />,
        isIndex: false,
        isLight: false,//true
        isHalfLight: false,
        isMenuLight: false,
      })
    })

    page('/funds/:id', (ctx) => {
      self.setState({
        container: <Found id={ctx.params.id} on404={this.handle404} />,
        isIndex: false,
        isLight: false,
        isHalfLight: false//true
      })
    })

    page('/actions', (ctx) => {
      self.setState({
        container: <Actions />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })

    page('/actions/:id', (ctx) => {
      self.setState({
        container: <Action id={ctx.params.id} on404={this.handle404} />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })
	
	page('/actions/:id/offer', (ctx) => {
      self.setState({
        container: <Offer id={ctx.params.id} on404={this.handle404} />,
        isIndex: false,
        isLight: false,
        isHalfLight: true
      })
    })

    page('/externalpartners', (ctx) => {
      self.setState({
        container: <ExternalPartners />,
        isIndex: false,
        isLight: false,//true
        isHalfLight: false,
        isMenuLight: false,
      })
    })

    page('/externalpartners/:id', (ctx) => {
      self.setState({
        container: <ExternalPartner id={ctx.params.id} on404={this.handle404} />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })

    page('/partners', (ctx) => {
      self.setState({
        container: <Partners />,
        isIndex: false,
        isLight: true,
        isHalfLight: false,
        isMenuLight: false,
      })
    })

    page('/news', (ctx) => {
      self.setState({
        container: <News />,
        isIndex: false,
        isLight: false,
        isHalfLight: false,
        isMenuLight: false,
      })
    })

    page('/news/:id', (ctx) => {
      self.setState({
        container: <Article articleId={ctx.params.id} on404={this.handle404} />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })

    page('/about', (ctx) => {
      self.setState({
        container: <About />,
        isIndex: false,
        isLight: false,
        isHalfLight: false,
        isMenuLight: false,
      })
    })
	
	page('/donate/netologiya', (ctx) => {
      self.setState({
        container: <Donate />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })

    page('/donate/bianca', (ctx) => {
      self.setState({
        container: <DonateOptions />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })
  
    page('/donate/kynsi', (ctx) => {
      self.setState({
        container: <DonateKynsi />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })
	
    page('/boardriders', (ctx) => {
      self.setState({
        container: <TravliNet />,
        isIndex: false,
        isLight: false,
        isHalfLight: false
      })
    })

    /*page('/checkout/:id', (ctx) => {
      self.setState({
        container: <Checkout id={ctx.params.id} on404={this.handle404} />,
        isIndex: false,
        isLight: true,
        isHalfLight: false
      })
    })

    page('/payments/:id', (ctx) => {
      self.setState({
        container: <Pay id={ctx.params.id} on404={this.handle404} />,
        isIndex: false,
        isLight: true,
        isHalfLight: false
      })
    })

    page('/video', (ctx) => {
      self.setState({
        container: <Video />,
        isIndex: false,
        isLight: true,
        isHalfLight: false
      })
    })

    page('/payments/:id/:tab', (ctx) => {
      self.setState({
        container: <Pay id={ctx.params.id} tab={ctx.params.tab} on404={this.handle404} />,
        isIndex: false,
        isLight: true,
        isHalfLight: false
      })
    })*/

    page('/assets/docs/:file(.*)', (ctx) => {//редирект на статические файлы
      if (ctx.params.file){
        var win = window.open("http://static.businessforcharity.today/" + ctx.params.file, '_self');
        win.focus();
      }
    })

    page('/:alias', (ctx) => {
      self.setState({
        container: <Static alias={ctx.params.alias} on404={this.handle404} />,
        isIndex: false,
        isLight: false,
        isHalfLight: true
      })
    })

    page('*', () => {
      self.setState({
        container: <NotFound />,
        isIndex: false,
        isLight: true,
        isHalfLight: false
      })
    })

    page()
    // ------------------------------------------------------------------------
    // End Routing

    window.freezeBody = function (isStatic) {
      if (!isStatic) self.setState({ isOverlap: true })

      bodyScrollTop = (typeof window.pageYOffset !== 'undefined') ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
      document.body.style.top = `-${bodyScrollTop}px`
      document.body.classList.add('is-freeze')
    }

    window.unfreezeBody = function (isStatic) {
      if (!isStatic) self.setState({ isOverlap: false })
      timeout(() => {
        document.body.classList.remove('is-freeze')
        document.body.style.top = null
        window.scrollTo(0, bodyScrollTop)
      }, 300)
    }
  }

  render () {
    if (this.props.fetching.initial) return null
    const { currentCountry, subscribe, subscribed, user, isLogged, logOut } = this.props
    const { modalState } = this.state

    return (
      <div className={classNames('Wrap', {
        '_light': this.state.isLight,
        '_half-light': this.state.isHalfLight
      })}>
        <Menu
          /*user={user}
          isLogged={isLogged}*/
          //
          isOpen={this.state.isMenuOpen}
          handleMenuClose={this.handleMenuClose}
          /*onOpenSigin={this.handleOpenSigin}
          logOut={logOut}
          onOpenCountrySelect={this.handleOpenRegion}*/
          openClaim={this.setModalState.bind(this, 'claim', true)}
          openSettings={this.setModalState.bind(this, 'edit', true)}
        />

        <Header
          /*user={user}
          isLogged={isLogged}*/
          //logOut={logOut}
          openClaim={this.setModalState.bind(this, 'claim', true)}
          openSettings={this.setModalState.bind(this, 'edit', true)}
          isIndex={this.state.isIndex}
          isDisable={this.state.isOverlap}
          handleMenuOpen={this.handleMenuOpen}
          onOpenSearch={this.handleOpenSearch}
          /*onOpenSigin={this.handleOpenSigin}
          onOpenCountrySelect={this.handleOpenRegion}*/
          isMenuLight={this.state.isMenuLight}
        />

        <div className={classNames('Background', {
          'Background_full': this.state.isLight,
          'Background_half': this.state.isHalfLight,
        })} />

        <div className={classNames('Background_mobile', {
          'Background_mobile_full': this.state.isLight
        })} />

        <div className={classNames('Content', {
          'Content--gradient': this.state.isMenuLight
        })}>
          <div className='Content__body'>
            {this.state.container}
          </div>
          <Footer onSubscribe={subscribe} loading={this.props.fetching.subscribe} isSubscribed={subscribed} />
        </div>

        <div className='Modals'>
          <Overlay isActive={this.state.isSearch} onClose={this.handleCloseSearch} styleModifier={{color: '#000000'}}>
            <Search onAfterClick={this.handleCloseSearch} />
          </Overlay>

          {/*<Overlay isActive={this.state.isSignin} onClose={this.handleCloseSigin}>
            <Signin onClose={this.handleCloseSigin} />
      </Overlay>

          <Overlay isActive={modalState.claim} onClose={this.setModalState.bind(this, 'claim', false)}>
            <ClaimForm />
          </Overlay>

          <Overlay isActive={modalState.edit} onClose={this.setModalState.bind(this, 'edit', false)}>
            <EditForm />
          </Overlay>

          <Overlay isActive={!currentCountry || this.state.isRegion} onClose={this.handleCloseRegion} klassModifier='is--blured'>
            <Region />
    </Overlay>*/}
        </div>
      </div>
    )
  }
}

// специальная вставка для того, чтобы перехватить идентификатор страны из адресной строки
// и подставить его как значение по умолчанию
// требуется для корректной обработки чекаут страниц при переходе из мобильного приложения
var urlParams = new URLSearchParams(window.location.search) // eslint-disable-line
if (urlParams.get('countryId')) {
  window.localStorage.setItem('countryId', urlParams.get('countryId'))
}

const mapStateToProps = state => ({
  user: getLoggedUser(state),
  isLogged: getIsLogged(state),
  subscribed: state.home.subscribed || null,
  currentLocale: state.intl.locale,
  currentCountry: window.localStorage.getItem('countryId') || null
})

const mapDispatchToProps = dispatch => bindActionCreators({ getUser, logOut, getContacts, subscribe, getCountries }, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...props,
  ...state,
  logOut: dispatch.logOut,
  subscribe: email => {
    if (!email) return
    if (!validator.validate(email)) return

    return props.fetchingWrap(dispatch.subscribe.bind(this, email), 'subscribe')
  },
  getInitialData: async () => {
    const getData = () => Promise.all([
      dispatch.getUser(),
      dispatch.getContacts(),
      dispatch.getCountries()
    ])

    return props.fetchingWrap(getData.bind(this), 'initial')
  }
})

export default fetchingState({ multi: true })(connect(mapStateToProps, mapDispatchToProps, mergeProps)(MainLayout))



// WEBPACK FOOTER //
// ./src/containers/Layout.jsx